// extracted by mini-css-extract-plugin
module.exports = {"logo":"Index1_logo__HJ_Pb","footer":"Index1_footer__3rL9X","social":"Index1_social__NscMz"};